import { BankConnectionsSection } from '@/components/ledgersync/BankConnectionsSection'
import { ManualBanksSection } from '@/components/manual-banks/ManualBanksSection'
import { FinancialAccountsPageHeader } from '@/components/financial-accounts/FinancialAccountsPageHeader'

/**
 * Banking settings page — the org-level home of bank connections.
 * Accessible at `/settings/financial-accounts`.
 *
 * Order matters. Bank Connections comes FIRST (DCP-324): connecting a bank is
 * the primary action here since AC#2 moved the connect flow off the per-facility
 * page, and a connection is an ORGANIZATION-level object. Manual banks follow,
 * listed and drilled into the same way as connections. (The facility-level "Bank
 * Connections Overview" that used to sit between them was removed as
 * redundant now that BankConnectionsSection already lists every connection
 * with its account count — DCP-324.)
 */
export function SettingsBankingPage() {
  return (
    <div className="space-y-6">
      <FinancialAccountsPageHeader scope={null} />
      <BankConnectionsSection scope={null} />
      <ManualBanksSection scope={null} />
    </div>
  )
}
